import { useEffect } from "react";
import useChatStore from "@/stores/useChatStore";
import { useParams } from "react-router-dom";

export default function useChatLoader() {
  const { chatId } = useParams();
  const loadConversationById = useChatStore((state) => state.loadConversationById);
  const handleFetchSuggestedQuestions = useChatStore((state) => state.handleFetchSuggestedQuestions);
  useEffect(() => {
    if (chatId) {
      loadConversationById(chatId);
      handleFetchSuggestedQuestions(chatId);
    }
  }, [chatId]);

  return null;
}
